import React from "react";
import { Avatar, Button, Card, Typography } from "antd";
import { UserOutlined } from "@ant-design/icons";

const { Text } = Typography;

const SingleApproveSubmissionCard = ({
  submission,
  handleApproveSubmit,
  loading,
}: any) => {
  return (
    <Card className={`p-6 py-3 rounded-lg border-none shadow-sm`}>
      <div className="flex items-center gap-4">
        <div>
          <Avatar
            size={60}
            src={
              submission?.profilePictureKey &&
              process.env.REACT_APP_CLOUDFRONT_KEY +
                "/" +
                submission?.profilePictureKey
            }
            icon={<UserOutlined />}
          />
        </div>
        <div className="flex flex-col  w-full">
          <Text className="text-neutral-700 font-semibold text-base line-clamp-2">
            {submission.name ?? submission.email}
          </Text>

          {submission.isFinished && submission.isApproved && (
            <>
              <div className="flex justify-between items-center w-full">
                <div className="text-success-550 font-medium text-sm">
                  Approved
                </div>
                <Button
                  loading={loading}
                  disabled={loading}
                  onClick={() =>
                    handleApproveSubmit(
                      submission?.submissionId,
                      !submission?.isApproved
                    )
                  }
                  type="link"
                  className="p-0 h-fit text-sm text-primary-600 bg-transparent border-none cursor-pointer"
                >
                  Disapprove
                </Button>
              </div>
              <div
                className={`mt-2 h-2 w-full bg-success-550 rounded-md`}
              ></div>
            </>
          )}
          {submission.isFinished && !submission.isApproved && (
            <>
              <div className="flex justify-between items-center w-full">
                <div className="text-primary-600 font-medium text-sm">
                  Submitted
                </div>
                <Button
                  loading={loading}
                  disabled={loading}
                  onClick={() =>
                    handleApproveSubmit(
                      submission?.submissionId,
                      !submission?.isApproved
                    )
                  }
                  type="link"
                  className="p-0 h-fit text-sm text-primary-600 bg-transparent border-none cursor-pointer"
                >
                  Approve
                </Button>
              </div>
              <div
                className={`mt-2 h-2 w-full bg-primary-500 rounded-md`}
              ></div>
            </>
          )}
          {!submission.isFinished && !submission.isApproved && (
            <>
              <div className="text-neutral-400 font-medium text-sm">
                Not submitted
              </div>
              <div
                className={`mt-2 h-2 w-full bg-neutral-200 rounded-md`}
              ></div>
            </>
          )}
        </div>
      </div>
    </Card>
  );
};

export default SingleApproveSubmissionCard;
